/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProfileMergeResource } from '../models/ProfileMergeResource';
import type { StoreProfileMergeRequest } from '../models/StoreProfileMergeRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PeopleProfileMergeService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProfileMerges(): CancelablePromise<{
        data: Array<ProfileMergeResource>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/profile-merges',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Store a newly created resource in storage.
     * @returns any Created
     * @throws ApiError
     */
    public createProfileMerge({
        requestBody,
    }: {
        /**
         * Profile Merge payload
         */
        requestBody: StoreProfileMergeRequest,
    }): CancelablePromise<{
        data: ProfileMergeResource;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/profile-merges',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Display the specified resource.
     * @returns any OK
     * @throws ApiError
     */
    public getProfileMerge({
        id,
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number,
    }): CancelablePromise<{
        data: ProfileMergeResource;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/profile-merges/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public deleteProfileMerge({
        id,
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/profile-merges/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public runProfileMerge({
        id,
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number,
    }): CancelablePromise<{
        data: ProfileMergeResource;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/profile-merges/{id}/run',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
            },
        });
    }

}
